import { useDates } from "../../../dates/DatesContext";
import moment from "moment";
import useDSPSellerInfo from "./useDSPSellerInfo";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { DatasetsQueryFilter } from "../../../zodios/apiDefinitions/api/dsp/common";

export const useDSPAudienceDatasetsQuery = (options?: {
  dimensions?: string | string[];
  segmentId?: string | number | null;
  lineItemId?: string | number | null;
  orderId?: string | number | null;
  lineItemIds?: (string | number)[] | null;
  enabled?: boolean;
}) => {
  const { start, end, preStart, preEnd } = useDates();
  const { dspAdvertiser } = useDSPSellerInfo();

  const startDate = moment(start).format("YYYY-MM-DD");
  const endDate = moment(end).format("YYYY-MM-DD");
  const preStartDate = moment(preStart).format("YYYY-MM-DD");
  const preEndDate = moment(preEnd).format("YYYY-MM-DD");

  const filters: DatasetsQueryFilter[] = [
    { id: "date", value: { op: "gte", value: startDate } },
    { id: "date", value: { op: "lte", value: endDate } },
    { id: "date_prev", value: { op: "gte", value: preStartDate } },
    { id: "date_prev", value: { op: "lte", value: preEndDate } },
  ];

  if (dspAdvertiser?.id) {
    filters.push({ id: "dsp_seller_info_id", value: { op: "eq", value: dspAdvertiser.id } });
  }

  if (options?.segmentId) {
    filters.push({ id: "segment_id", value: { op: "eq", value: options.segmentId } });
  }

  if (options?.lineItemId) {
    filters.push({ id: "line_item_id", value: { op: "eq", value: options.lineItemId } });
  }

  if (options?.orderId) {
    filters.push({ id: "order_id", value: { op: "eq", value: options.orderId } });
  }

  if (options?.lineItemIds?.length) {
    filters.push({ id: "line_item_id", value: { op: "in", value: options.lineItemIds } });
  }

  const dimensions = options?.dimensions ?? ["segment_id"];

  const body = {
    model: "dspaudience" as const,
    dimensions,
    filters,
  };

  return useQuery({
    queryKey: ["dspAudienceDatasets", startDate, endDate, preStartDate, preEndDate, dimensions, filters],
    enabled: options?.enabled !== undefined ? options.enabled : !!dspAdvertiser?.id,
    queryFn: async () => {
      return await apiClient.dspAudienceDatasetsQuery(body);
    },
  });
};
